<template>
    <section class="container">
        <div class="row">
            <div class="col">
                Home
            </div>
        </div>
    </section>
</template>

<script setup>
</script>

<style scoped></style>